import { FieldRenderProps } from '@progress/kendo-react-form';
import React from 'react';
import { MaskedTextBox } from '@progress/kendo-react-inputs';
import { SSN_EMPTY_MASK } from 'utility/constants';
// @ts-ignore
import styles from './form.module.scss';

interface CustomSSNInputProps extends FieldRenderProps {
  label: string,
  id: any,
  className: any,
  readOnly: boolean
}

export const CustomSSNInput = (props: CustomSSNInputProps) => {
  const formatToMask = (input: string) => {
    let formatted = '';
    let index = 0;
    const maskPattern = '000-00-0000';
    const maskLength = maskPattern.length;

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < maskLength; i++) {
      if (maskPattern[i] === '-') {
        formatted += '-';
      } else if (index < input.length) {
        // eslint-disable-next-line no-plusplus
        formatted += input.charAt(index++);
      } else {
        break;
      }
    }

    while (formatted.length < maskPattern.length) {
      if (maskPattern[formatted.length] === '-') {
        formatted += '-';
      } else {
        formatted += '_';
      }
    }

    return formatted;
  };

  const defaultValue = props.value && props.value !== SSN_EMPTY_MASK ? formatToMask(props.value) : '';

  return (
    <MaskedTextBox
      label={props.label}
      id={props.id}
      className={`${props.className ?? ''} ${props.readOnly ? styles.readOnly : ''}`}
      mask="000-00-0000"
      defaultValue={defaultValue}
      onChange={props.onChange}
      readonly={props.readOnly}
    />
  );
};
